import { Paper, Stack, Text, Title } from '@mantine/core';
import { useParams } from 'wouter';
import Link from '@/components/Link';
import { listUrl } from '@/lib/listMemory';
import { type PersonCardResponse, usePersonCard } from '@/models/persons';
import { PersonView } from '@/pages/persons/PersonPage';

export default function LeadRoute() {
  const params = useParams<{ id: string }>();
  const id = Number(params.id);
  const { data, isLoading } = usePersonCard({ leadId: id });
  if (isLoading) return null;
  const card = data as PersonCardResponse | undefined;
  if (!card?.person) {
    return (
      <Paper withBorder p="xl" maw={520} mx="auto" mt="xl">
        <Stack gap="xs" align="center">
          <Title order={4}>Lead not accessible</Title>
          <Text size="sm" c="dimmed" ta="center">
            Lead #{id} either does not exist or is assigned to another sales
            representative. Ask an admin or the current assignee to grant you
            access.
          </Text>
          <Link to={`~${listUrl('/leads')}`}>Back to leads</Link>
        </Stack>
      </Paper>
    );
  }
  return <PersonView key={`${card.person.id}-${id}`} data={card} />;
}
